import styled from 'styled-components';
import { Icon } from '@iconify/react';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding-inline: 10px;
`;

export const ValueContainer = styled.div`
  
`;

export const Text = styled.span`
  font-size: 12px;
`;

export const Valor = styled.h3`
  color: #198754;
`;

export const BoletoContainer = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BoletoSpinner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export const BoletoIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;
